<script>
export default {
  name: "chatbotsection",
  methods: {
    scrollTo($event) {
        const targetQuery = $event.target.getAttribute('href');
        const targetEl = document.querySelector(targetQuery);

        targetEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
        window.history.pushState(null, null, targetQuery);
    },
  },
}
</script>

<template>
    <div class="row chatbot-section">
        <div class="container">
            <section class="section">
                <div class="text-chatbot">
                    <h2>
                        <span class="title-chatbot">Construa seu site com a gente</span>
                    </h2>
                    <p>
                      Inicie sua campanha de arrecadação em minutos. Com o Voto Legal é fácil você criar e publicar um site atraente e personalizável. Use vídeos, apresente suas propostas para doadores e acompanhe em tempo real o progresso da sua meta.
                    </p>
                    <p>
                      Em poucos cliques, sem burocracia, você coloca no ar sua campanha integrada com meios de pagamentos que dão segurança aos doadores. Com o voto Legal, sua arrecadação está segura.
                    </p>
                    <a
                      class="call-to-action-button"
                      @click.prevent="scrollTo"
                      href="#email"
                    >
                      Quero começar
                    </a>
                </div>

                <img class="img-chatbot"
                  src="../../img/sites/sites.jpg"
                  srcset="../../img/sites/sites.jpg 1x, ../../img/sites/sites@2x.jpg 2x, ../../img/sites/sites@3x.jpg 3x"
                  alt="Construtor de sites"
                />

            </section>
        </div>
    </div>
</template>

<style lang="scss" scoped>

  .call-to-action-button {
    margin-top: 1rem;
    display: inline-block;
    padding: 0.6rem 2rem;
    color: #fff;
    text-align: center;
    text-transform: uppercase;
    font-size: 1em;
    font-weight: 600;
    border: 2px solid #fff;
    border-radius: 8px;
    background-color: transparent;
  }

    .chatbot-section {
      background-color: #0aba7e;

    }
    .section {
        overflow: hidden;
    }

    @media screen and (min-width: 768px) {
        .text-chatbot {
            float: right;
            width: 50%;
        }
    }

    .title-chatbot {
        color: #ffffff;
    }

    .text-chatbot p {
        font-size: 18px;
        line-height: 2;
		color: #ffffff;

		@media (max-width: 913px) {
			margin-bottom: 2em;
		}
    }


    .img-chatbot {
        ---position: relative;
        margin-left: 0;
        margin-right: auto;
        display: block;
    }
</style>

<style scoped>

</style>



// WEBPACK FOOTER //
// _source/javascript/components/chatbotsection.vue